import axios from 'axios'
import { createCommonInterceptors } from '../common-interceptors'

export const commonHttpClient = axios.create({
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

export const initializeCommonHttpClientInterceptors = () => {
  createCommonInterceptors(commonHttpClient)
}
